import React, { useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components/macro";
import { Colors, Constants } from "../odc-ui";
import HomePageVideoBanner from "../../assets/images/home-page-video-banner.jpg";

const mountPointId = "hero-video-player-mount-point";

const HeroVideoPlayerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  background: black;
`;

const HeroVideoBannerContainer = styled.div`
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  overflow: hidden;

  /* @media only screen and (max-width: 760px) {
    height: auto;
  } */
`;

const PlayButtonCircle = styled.a`
  position: relative;
  z-index: 1;

  box-sizing: border-box;
  display: block;
  width: 120px;
  height: 120px;
  padding-top: 30px;
  padding-left: 8px;
  line-height: 20px;
  border: 6px solid #fff;
  border-radius: 50%;
  color: #f5f5f5;
  text-align: center;
  text-decoration: none;
  background-color: rgba(0, 0, 0, 0.8);
  font-size: 25px;
  font-weight: bold;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background-color: ${Colors.gold200};
    box-shadow: 0px 0px 10px ${Colors.gold200};
    text-shadow: 0px 0px 10px ${Colors.gold200};
  }
`;

const HomePageVideoBannerImg = styled.img`
  height: 140%;
  object-fit: cover;

  @media ${Constants.style.mobileAndDownMediaQuery} {
    height: auto;
    width: 100%;
    object-fit: contain;
  }
`;

const StyledVideo = styled.video`
  z-index: 1;
  position: relative;
  object-fit: contain;
  height: 100%;
  width: 100%;
`;

const HeroVideoPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <HeroVideoPlayerContainer>
      {isPlaying ? (
        <StyledVideo controls autoPlay onEnded={() => setIsPlaying(false)}>
          <source src="/Healthcoin.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </StyledVideo>
      ) : (
        <>
          <HeroVideoBannerContainer>
            <HomePageVideoBannerImg src={HomePageVideoBanner} />
          </HeroVideoBannerContainer>
          <PlayButtonCircle
            onClick={(e) => {
              e.preventDefault();
              setIsPlaying(true);
            }}
          >
            <i className="fa fa-play fa-2x"></i>
          </PlayButtonCircle>
        </>
      )}
    </HeroVideoPlayerContainer>
  );
};

document.addEventListener("DOMContentLoaded", () => {
  const mountPoint = document.getElementById(mountPointId);

  if (mountPoint) {
    ReactDOM.createRoot(mountPoint).render(<HeroVideoPlayer />);
  }
});
